import { useState, useEffect } from 'react';

import firebase from '../../firebase';

const auth = firebase.auth();

export default function useFirebaseUser () {
  const [firebaseUser, setFirebaseUser] = useState();
  const [emailVerified, setEmailVerified] = useState(false);
  const [signInSecondFactor, setSignInSecondFactor] = useState(null);
  const reloadEmailVerified = async () => {
    if(firebaseUser == null) return;

    firebaseUser && await firebaseUser.reload();
    setEmailVerified(auth.currentUser.emailVerified);
  };
  useEffect(() => {
    auth.onAuthStateChanged((firebaseUser) => {
      setFirebaseUser(firebaseUser);
      setEmailVerified(firebaseUser && firebaseUser.emailVerified);
    });
    auth.onIdTokenChanged(async (firebaseUser) => {
      setSignInSecondFactor((await firebaseUser?.getIdTokenResult())?.signInSecondFactor ?? null);
    });
  }, []);

  return { firebaseUser, emailVerified, reloadEmailVerified, signInSecondFactor };
};
